export default function (selectedSnippet, title, callback)
{
    let self = this;

    const showMessage = (message, isError) =>
    {
        const alertSave = $('.save-content')
        alertSave.fadeIn(500)
        alertSave.removeClass(isError ? 'alert-success' : 'alert-danger alert-warning')
        alertSave.addClass(isError ? 'alert-danger' : 'alert-success')
        alertSave.html(message)
        alertSave.fadeOut(3000)
    }

    const sendCreate = (content, title, callback) => $.ajax({
        type: "post",
        url: `${self.options.apiUserComponents}`,
        headers: {
              Authorization: self.options.accessToken,
        },
        data: {
            title: title,
            template: content,
        },
        success: function (resp) {
            if(typeof callback === "function")
            {
                callback.call(self, true, resp.data);
            }
        },
        error: function (jqXHR) {
            if (typeof callback === "function")
            {
                callback.call(self, false, jqXHR);
            }
        },
    });

    sendCreate(selectedSnippet, title, function (success, resp)
    {
        if (success)
        {
            showMessage('Bloco criado com sucesso!', false);
        }
        else
        {
            showMessage('Não foi possível criar o bloco! Entre em contato com o administrador', true);
        }

        if (typeof callback === "function")
        {
            callback.call(self, success, resp);
        }
    });
}